import { Breakpoint } from './breakpoints';

interface BreakpointWrapperProps {
  breakpoint?: Breakpoint;
}

export const setMediaQuery = ({ breakpoint }: BreakpointWrapperProps) => (str: string): string => {
  if (breakpoint === undefined || (breakpoint.maxWidth === undefined && breakpoint.minWidth === undefined)) {
    return str;
  }

  const { minWidth, maxWidth } = breakpoint;

  const conditions: string[] = [];
  if (minWidth !== undefined) {
    conditions.push(`(min-width: ${minWidth}px)`);
  }
  if (maxWidth !== undefined) {
    conditions.push(`(max-width: ${maxWidth}px)`);
  }

  const conditionStr = conditions.join(' and ');

  const res = `
    @media ${conditionStr} {
        ${str}
    }
  `;
  return res;
};

export const getColumnSpacingRules = (spacingBetweenItemsHalved: string) => `
  & > * {
    margin-top: ${spacingBetweenItemsHalved};
    margin-bottom: ${spacingBetweenItemsHalved};
  }
  & > *:first-child {
    margin-top: 0;
  }
  & > *:last-child {
    margin-bottom: 0;
  }
`;

export const getRowSpacingRules = (spacingBetweenItemsHalved: string) => `
  & > * {
    margin-left: ${spacingBetweenItemsHalved};
    margin-right: ${spacingBetweenItemsHalved};
  }
  & > *:first-child {
    margin-left: 0;
  }
  & > *:last-child {
    margin-right: 0;
  }
`;
